import React, {useState, useEffect} from 'react';

function ContactPage() {
  useEffect(() => {

  }, []);

  return (
    <div className="p-4">
      <h1 className="text-4xl font-bold mb-4">Get in contact</h1>
      <div className="flex items-center border-b py-2">
        <a href="https://wa.me/447967148166" className='mb-1 mt-8' target="_blank" rel="noreferer">
          <img src="img/whatsapp_logo_green.png" alt="whatsapp" className="mr-5"/> 
          <h2 className='text-3xl mb-1 mt-8 mr-5'>WhatsApp: 07967 148 166</h2>
          <p className=' mt-5 mr-5'>(Best for urgent issues with orders)</p>
        </a>  
      </div>
      <div className="flex items-center border-b py-2">
         <h2 className='text-3xl mb-1 mt-8 mr-5'>Email:</h2>
         <a href="mailto:info@houseofcrust.co.uk" className='text-3xl mb-1 mt-8'>info@houseofcrust.co.uk</a>
      </div>
    </div>
  );
}

export default ContactPage;
